<template>
    <d-container fluid class="main-content-container px-4">
        <d-row>
            <d-col lg="12" class="mx-auto mt-4">
                <h3 class="page-title">Billing</h3>
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-header class="border-bottom">
                        <h5>Billing Information</h5>
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">1. Select monthly billing plan</h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title"><u>2. Billing address</u></h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">3. Payment method</h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body class="p-0">
                        <d-form id="billingForm" @submit.prevent="saveForm" class="py-4">
                            <d-form-row class="mx-4">
                                <d-col class="mb-3">
                                    <d-form-text tag="h6" class="m-0">Your billing address</d-form-text>
                                </d-col>
                            </d-form-row>
                            <d-form-row class="mx-4">
                                <d-col lg="12">
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label for="country">Country</label>
                                            <d-form-select required v-model="userInfo.country">
                                                <option v-for="item in Countries" :value="item">{{ item.name }}</option>
                                            </d-form-select>
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="state">State</label>
                                            <d-input required type="text" id="state" placeholder="Enter your address" v-model="userInfo.state" />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="companyName">Company name</label>
                                            <d-input required required minlength="3" id="companyName" placeholder="Enter a company name" v-model="userInfo.company" />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="zipCode">Zip code</label>
                                            <d-input required minlength="3" type="text" id="zipCode" placeholder="Enter your zip code" v-model="userInfo.postcode" />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="adressLine1">Street</label>
                                            <d-input required minlength="3" type="text" id="Street" placeholder="Enter your address" v-model="userInfo.address_1" />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="city">City</label>
                                            <d-input-group seamless>
                                                <d-input-group-text slot="prepend">
                                                    <i class="material-icons">&#xE0C8;</i>
                                                </d-input-group-text>
                                                <d-input required minlength="3" id="userLocation" v-model="userInfo.city" />
                                            </d-input-group>
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label for="housenumber">House number</label>
                                            <d-input required type="text" @keydown.native.space.prevent id="housenumber" placeholder="Enter your address" v-model="billingInfo.houseNumber" />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label v-if="!billingInfo.noTax" for="vat">VAT Number</label>
                                            <d-input required minlength="3" v-if="!billingInfo.noTax" type="text" id="vat" v-model="userInfo.vat" />
                                            <d-checkbox class="mt-4" v-model="billingInfo.noTax" value="true">I do not have a VAT Number</d-checkbox>
                                        </d-col>
                                    </d-form-row>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-card-body>
                    <d-card-footer class="border-top d-flex justify-content-end">
                        <d-link tag="button" class="btn btn-secondary" :to="{ name: 'billing' }">Back</d-link>
                        <input type="submit" value="Next" form="billingForm" class="btn ml-3 btn-success" />
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
    import { CountryResource, UserService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                percent: 50,
                Countries: []
            };
        },

        methods: {
            getHouseNumber() {
                if (this.billingInfo.houseNumber === '') {
                    this.billingInfo.houseNumber = this.userInfo.address_1.replace(/\D/g, '')
                }
                this.userInfo.address_1 = this.userInfo.address_1.replace(/(?:\d+[a-z]*)$/g, '').trim();
            },

            async getCountries() {
                try {
                    const countries = await CountryResource.get()
                    this.Countries = countries.data.countries
                } catch(e) {
                    this.showNotification('warn', 'Alert', 'Can not get countries')
                    console.log(e)
                }
            },

            async saveForm() {
                const billingAddress = []

                if (this.billingInfo.noTax) {
                    this.userInfo.vat = null
                }

                billingAddress.push(this.userInfo.state, this.userInfo.city, this.userInfo.address_1, this.userInfo.postcode, this.userInfo.vat, this.userInfo.company, this.userInfo.country.code)

                this.$store.commit('setHouseNumber', this.billingInfo.houseNumber)
                this.$store.commit('setNoTax', this.billingInfo.noTax)
                this.$store.commit('setBillingAddress', billingAddress)
                this.$store.commit('setCountry', this.userInfo.country)
                await UserService.updateAddress(this.userInfo.country.code, this.userInfo.state, this.userInfo.company, this.userInfo.postcode, this.userInfo.address_1 + ' ' + this.billingInfo.houseNumber, this.userInfo.city, this.userInfo.vat)

                this.$router.push('/payment-method')
            },
        },

        created() {
            this.getCountries()
            this.getHouseNumber()
        },

        computed: {
            userInfo () {
                if (this.$store.getters.getBillingInfo.planId) {
                    return this.$store.getters.userInfo
                } else {
                    this.$router.push('/billing')
                }
            },

            billingInfo () {
                if (this.$store.getters.getBillingInfo.planId) {
                    return this.$store.getters.getBillingInfo
                }
            }
        },
    };
</script>
